module.exports = __webpack_public_path__ + "img/logo.1c6631ed.png";